module.exports = __webpack_public_path__ + "static/media/academic coordinator.218b32e5.svg";